module.exports = __webpack_public_path__ + "img/title.fcf186ff.png";